import React from 'react';

import { AppLayoutContainer } from '../components/app/AppLayout';
import { AppSelectorContainer } from '../components/app-selector/AppSelector';
import { AppSelectorLayout } from '../components/app/AppSelectorLayout';

const AppSelectorRoute = () => {
  const handleAddProductsToAccountClick = (url: string) => {
    window.location.href = url;
  };

  return (
    <AppLayoutContainer>
      <AppSelectorLayout>
        <AppSelectorContainer
          onAddProductsToAccountClick={handleAddProductsToAccountClick}
        />
      </AppSelectorLayout>
    </AppLayoutContainer>
  );
};

export default AppSelectorRoute;
